// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "seats__header-1s5Vj";
export { _1 as "__esModule", _2 as "seats__header" }
export default { "__esModule": _1, "seats__header": _2 }
